<template>
  <div></div>
</template>

<script>
  export default {
    name: "receiversBill"
  }
</script>

<style scoped>

</style>
